module.exports = __webpack_public_path__ + "assets/campaign-delete-active.934a12a5.svg";